export default {
  OK: "OK",
  ok: "OK",
  loginFailed: "登录失败,请重试。",
  requestFailed: "请求失败,请检查您的互联网连接。",
  invalidLogin: "无效的用户名或密码。",
  thisFunctionExists: "此功能不允许删除。",
  thisFunctionNotAllowDelete: "此功能不存在。",
  thisFunctionNotExists: "目标功能ID是必需的。",
  targetFunctionIdRequired: "此页面已存在。",
  thisPageExists: "此页面不允许删除。",
  thisPageNotAllowDelete: "此角色已存在。",
  thisRoleExists: "此角色不允许删除。",
  thisRoleNotAllowDelete: "目标角色ID是必需的。",
  targetRoleIdRequired: "无效的参数。",
  invalidParameter: "系统无法处理您的请求。",
  systemError: "SP消息错误(根据错误情况而定)。",
  spErrorMessage: "当前用户是必需的。",
  actionbyRequired: "会话令牌是必需的。",
  sessionTokenRequired: "功能ID是必需的。",
  functionIdRequired: "功能名称是必需的。",
  functionNameRequired: "功能名称是必需的。",
  newFunctionNameRequired: "页面ID是必需的。",
  pageIdRequired: "页面ID是必需的。",
  newPageIdRequired: "页面名称是必需的。",
  newPageNameRequired: "目标页面ID是必需的。",
  targetPageIdRequired: "用户ID是必需的。",
  passwordRequired: "全名是必需的。",
  userNameRequired: "密码必须是6-20个字符,包含数字和字母的组合。",
  passwordValidation: "页码是必需的。",
  pageNumRequired: "页面大小是必需的。",
  pageSizeRequired: "角色ID是必需的。",
  roleIdRequired: "当前密码是必需的。",
  oldPasswordRequired: "用户状态是必需的。",
  userStatusRequired: "角色ID是必需的。",
  newRoleIdRequired: "角色名称是必需的。",
  newRoleNameRequired: "开始日期是必需的。",
  startDateIsGteEndDate: "此角色不存在。",
  thisRoleNotExists: "此页面不存在。",
  thisPageNotExists: "此用户已存在。",
  thisUserExists: "此用户不存在。",
  thisUserNotExists: "您的帐户已被暂停。",
  thisUserBlackListed: "您的帐户已被禁用。",
  thisUserInactive: "您的帐户已被阻止。",
  thisUserBlocked: "您的帐户已被禁用。",
  thisUserNotActive: "无效的页面功能。",
  InvalidPageFunction: "无效的用户！",
  invalidUser: "无效的会话！",
  invalidToken: "无效的会话！",
  NoUserAccessRight: "权限被拒绝！",
  connection: "连接错误",
  profileIdRequired: "需要个人资料 ID。",
  packageIdRequired: "需要套餐 ID。",
  fullNameMinThreeChar: "全名必须至少有 3 个字符。",
  accountIdMinThreeChar: "帐户 ID 必须至少有 3 个字符。",
  searchCriteriaRequired: "需要搜索条件。",
  affiliateIdRequired: "需要代理 ID。",
  minDepositRequired: "需要最低存款。",
  bonusRateRequired: "需要奖金比例。",
  onlyAllowRejectDeposit: "仅允许拒绝存款工单。",
  senderBankIdRequired: "需要发送方银行 ID。",
  senderBankAccNoRequired: "需要发送方银行帐号。",
  minFTDAmtNumOnly: "最低首次存款金额只接受数字。",
  maxFTDAmtNumOnly: "最大首次存款金额只接受数字。",
  crmBasicCriteriaRequired: "会员 ID / 联系电话 / 联系电子邮件 / 注册日期 / 上次登录日期是必需的。",
  verifiedDateRangeAllowThreeMonths: "注册日期范围只允许选择最多 3 个月。",
  lastLoginDateRangeAllowThreeMonths: "上次登录日期范围只允许选择最多 3 个月。",
  depositDateRangeAllowThreeMonths: "存款日期范围只允许选择最多 3 个月。",
  ftdDateRangeAllowThreeMonths: "首次存款日期范围只允许选择最多 3 个月。",
  ltdDateRangeAllowThreeMonths: "持续存款日期范围只允许选择最多 3 个月。",
  lastLoginDateEarlierThanVerifiedDate: "上次登录日期早于注册日期。",
  depositDateEarlierThanVerifiedDate: "存款日期早于注册日期。",
  ftdDateEarlierThanVerifiedDate: "首次存款日期早于注册日期。",
  ltdDateEarlierThanVerifiedDate: "持续存款日期早于注册日期。",
  ftdFromRequired: "需要首次存款起始日期。",
  ftdToRequired: "需要首次存款结束日期。",
  ltdFromRequired: "需要持续存款起始日期。",
  ltdToRequired: "需要持续存款结束日期。",
  failedToLaunchPaymentGateway: "无法启动支付网关。",
  enTitleRequired: "需要EN标题。",
  enBodyRequired: "需要EN正文。",
  enImageUrlRequired: "需要EN图片网址。",
  enImageUrlDesktopRequired: "需要EN桌面图片网址。",
  enAltRequired: "需要EN图像替代文本。",
  enHrefRequired: "需要EN链接网址。",
  resubmitTicketRequired: "需要重新提交工单。",
  withtholdBonusAndAmountGreaterThanZero: "预扣奖金和预扣金额不能同时大于零。",
  maxWithdrawMultipleAndAmountGreaterThanZero: "最大提款乘数和最大提款金额不能同时大过零。",
  serverBusy: "服务器忙,请稍后重试。",
  isRequired: "请输入{fname}。",
  isMinValue: "{fname}必须至少有{fvalue}。",
  isMaxValue: "{fname}必须小于或等于{fvalue}。",
  isMinLength: "{fname}必须至少有{fvalue}个字符。",
  isMaxLength: "{fname}必须小于或等于{fvalue}个字符。",
  isAlpha: "{fname}只接受字母。",
  isAlphaNum: "{fname}只接受字母数字。",
  isNumeric: "{fname}只接受数字。",
  isEmail: "{fname}只接受有效的电子邮件地址。",
  isIpAddress: "{fname}只接受有效的IPv4地址。",
  isSameAs: "{fname}必须与{fname2}相同。",
  isUrl: "{fname}只接受URL。",
  containAlphaNum: "{fname}必须至少包含一个字母和一个数字。",
  alphaNumWithSpace: "{fname}只接受字母数字。",
  isDecimal: "{fname}只接受数字。",
  isInteger: "{fname}只接受整数。",
  selectOption: "请选择{fname}。",
  notSameAs: "{fname}和{fname2}不能相同。",
  dateRangeAllowOneMonth: "日期范围仅允许选择最多1个月。",
  dateRangeAllowOneYear: "日期范围仅允许选择最多1年。",
  greaterThanZero: "{fname}必须大于零。",
  atLeastOneAuthority: "必须至少选择一个权限。",
  BLOCK: "您的帐户已被阻止。",
  SUSPEND: "您的帐户已被暂停。",
  CLOSE: "您的帐户已关闭。",
  RESETL: "您的帐户已重置。",
  atLeastOneProvider: "必须至少选择一个提供者。",
  failedToGetResultUrl: "获取结果网址失败。",
  fileSizeValidation: "太大,最大允许大小为1MB。",
  atLeastOnePaymentOption: "必须至少选择一个付款选项。",
  atLeastOnePaymentGateway: "必须选择至少一个支付网关。",
  dateRangeAllow31Days: "日期范围仅允许选择最多31天。",
  dateRangeAllow31Months: "日期范围仅允许选择最多31个月。",
  dateRangeAllow31Years: "日期范围仅允许选择最多31年。",
  invalidCategory: "无效的类别",
  noChanges: "没有更改",
  permissionDenied: "权限被拒绝",
  referralCodeRequired: "需要推荐代码。",
  providerDescRequired: "提供者描述为必填项。",
  marqueeContentRequired: "跑马灯内容为必填项。",
  bonusNameRequired: "需要奖金名称。",
  baseAmountRequired: "需要基础金额。",
  reviewIdRequired: "需要审核 ID。",
  surveyIdRequired: "需要调查ID。",
  questionRequired: "需要问题。",
  iframeIdRequired: "Iframe ID为必填项。",
  bonusAmountRequired: "需要奖金金额。",
  inboxIdRequired: "收件箱ID为必填项。",
  exchangedAmountRequired: "兑换金额为必填项。",
  baseRateRequired: "基础汇率为必填项。",
  exchangeRateRequired: "兑换汇率为必填项。",
  baseCurrencyRequired: "基础货币为必填项。",
  exchangeCurrencyRequired: "兑换货币为必填项。",
  depositTypeRequired: "存款类型为必填项。",
  nbRedepositRequired: "需要无奖金重新存款。",
  bankOwnerRequired: "银行账户所有者为必填项。",
  autoSenderRequired: "自动发送者为必填项。",
  isRecommendRequired: "是否推荐为必填项。",
  recipientBankIdRequired: "接收方银行 ID 是必需的。",
  recipientBankAccNoRequired: "接收方银行帐户号码是必需的。",
  accountBalanceRequired: "需要帐户余额。",
  incomingAmountThresholdRequired: "需要收款金额阈值。",
  incomingFrequencyThresholdRequired: "需要收款频率阈值。.",
  outgoingAmountThresholdRequired: "需要付款金额阈值。",
  outgoingFrequencyThresholdRequired: "需要付款频率阈值。",
  bankAccTypeRequired: "需要银行帐户类型。",
  packageRequired: "需要套餐。",
  rtpRequired: "需要 RTP。.",
  domainIdRequired: "域名ID是必需的",
  buyOnBehalfRequired: "代购为必填项。",
  serviceProviderRequired: "服务提供商为必填项。",
  serverAccountRequired: "服务器账户为必填项。",
  nameServerRequired: "名称服务器为必填项。",
  socialLinkRequired: "社交链接为必填项。",
  newSocialPlatformRequired: "新的社交平台为必填项。",
  attachmentPathRequired: "附件路径为必填项。",
  depositMethodRequired: "需要存款方式。",
  depositDateRequired: "需要存款日期。",
  refNoRequired: "需要参考号。",
  withdrawalAmountRequired: "提款金额为必填项。",
  targetBankAccNoRequired: "需要目标银行帐户号码。",
  targetBankIdRequired: "需要目标银行 ID。",
  jsonRatingRequired: "JSON评分为必填项。",
  startTimeRequired: "需要开始时间。",
  accountIdRequired: "需要帐户 ID。",
  parentIdRequired: "需要上级 ID。",
  amountRequired: "需要金额。",
  clientIpRequired: "客户端IP为必填项。",
  auditByRequired: "需要审核者。",
  systemTypeRequired: "系统类型为必填项。",
  currencyRequired: "货币是必需的",
  ipAddressRequired: "需要 IP 地址。",
  affiliateCodeRequired: "代理代码为必填项。",
  contactPhoneRequired: "需要联系电话。",
  requestTypeRequired: "需要请求类型。",
  securityDisabledRequired: "需要禁用安全。",
  gameCodeRequired: "需要游戏代码。",
  seqRequired: "需要顺序。",
  minLimitRequired: "需要最小限额。",
  maxLimitRequired: "需要最大限额。",
  commSportsRequired: "需要体育博彩佣金。",
  commSlotsRequired: "需要老虎机佣金。",
  commLivecasinoRequired: "需要真人娱乐佣金。",
  commCockfightRequired: "需要斗鸡佣金。",
  commOthersRequired: "需要其他佣金。",
  settingValueRequired: "需要设置值。",
  vipIdRequired: "需要 VIP ID。",
  carryOverRequired: "需要结转。",
  campaignIdRequired: "需要活动 ID。",
  titleRequired: "需要标题。",
  bodyRequired: "需要正文",
  itemOrderRequired: "需要项目顺序。",
  imageUrlRequired: "需要图片网址。",
  bannerIdRequired: "需要横幅 ID。",
  directionRequired: "需要方向。",
  defaultOrderRequired: "默认排序为必填项。",
  altRequired: "需要图像替代文本。",
  hrefRequired: "需要链接网址。",
  targetWindowRequired: "需要目标窗口。",
  loginRequiredRequired: "需要登录要求。",
  activeFromRequired: "开始时间为必填项。",
  activeToRequired: "结束时间为必填项。",
  bannerTypeRequired: "需要横幅类型。",
  pageNameRequired: "需要页面名称。",
  remarkRequired: "需要备注。",
  settingKeyRequired: "需要设置键。",
  memberListRequired: "需要会员列表。",
  memberIdRequired: "会员ID为必填项。",
  workingMonthRequired: "需要工作月份。",
  workingDateRequired: "需要工作日期。",
  tacRequired: "条款与条件为必填项。",
  paymentModeRequired: "需要付款方式。",
  newPasswordRequired: "需要新密码。",
  loginIdRequired: "需要登录 ID。",
  securityTagRequired: "需要安全标签。",
  securityCodeRequired: "需要安全代码。",
  providerCodeRequired: "需要提供者代码。",
  startDateRequired: "开始日期是必需的。",
  endDateRequired: "结束日期是必需的。",
  searchIdRequired: "搜索ID为必填项。",
  authTokenRequired: "需要身份验证令牌。",
  newStatusRequired: "需要新状态。",
  actionRequired: "操作为必填项。",
  promotionIdRequired: "需要促销 ID。",
  promotionNameRequired: "需要促销名称。",
  rolloverRequired: "需要滚动要求。",
  criteriaRequired: "需要条件。",
  ticketIdRequired: "需要工单ID。",
  resultIdRequired: "需要结果 ID。",
  bankIdRequired: "需要银行 ID。",
  bankAccNoRequired: "需要银行帐户号码。",
  bankAccHolderRequired: "需要银行帐户持有人。",
  newBankIdRequired: "需要新银行 ID。",
  newBankAccNoRequired: "需要新银行帐户号码。",
  newBankAccHolderRequired: "需要新银行帐户持有人。",
  fullNameRequired: "全名为必填项。",
  depositAmountRequired: "需要存款金额。",
  gatewayAccRequired: "网关账户为必填项。",
  labelNameRequired: "标签名称为必填项。",
  labelIdRequired: "标签ID为必填项。",
  bankTypeRequired: "银行类型为必填项。",
  amountLimitRequired: "金额限制为必填项。",
  currencyRateRequired: "汇率为必填项。",
  urlRequired: "需要图片网址。",
  cashRequired: "现金为必填项。",
  csRequired: "客户支持为必填项。",
  vipNameRequired: "VIP名称为必填项。",
  campaignNameRequired: "需要活动名称。",
  transferIdRequired: "转账ID为必填项。",
  betTimeRequired: "投注时间为必填项。",
  turnoverRequired: "流水为必填项。",
  payoutRequired: "派彩为必填项。",
  winloseRequired: "输赢为必填项。",
  rawMessageRequired: "原始消息为必填项。",
  authStatusRequired: "认证状态为必填项。",
  dateRequired: "需要日期。",
  betIdRequired: "投注ID为必填项。",
  betStatusRequired: "投注状态为必填项。",
  betAmountRequired: "投注金额为必填项。",
  isParlayRequired: "是否为串关为必填项。",
  isAddonRequired: "是否为附加项为必填项。",
  withholdBonusRequired: "需要保留奖金。",
  withholdAmountRequired: "需要保留金额。",
  maxWithdrawAmountRequired: "需要最大提款金额。.",
  betTypeRequired: "投注类型为必填项。",
  maxWithdrawMultipleRequired: "需要最大提款乘数。",
  socialPlatformRequired: "需要社交平台。.",
  vipProviderRebateRequired: "VIP供应商返点为必填项。",
  selfRebateRateRequired: "需要自我返利率。",
  downlineRebateRateRequired: "需要下线返利率。",
  tierIdRequired: "层级ID为必填项。",
  rebateRateRequired: "需要返利率。",
  paymentGatewayRequired: "支付网关为必填项。",
  rescueIdRequired: "救援ID为必填项。",
  rescueNameRequired: "救援名称为必填项。",
  rescueCycleRequired: "救援周期为必填项。",
  minLoseRequired: "最小亏损为必填项。",
  rescueRateRequired: "救援率为必填项。.",
  maxPayoutRequired: "最大支付额为必填项。",
  payoutMethodRequired: "支付方式为必填项。",
  targetGroupRequired: "目标群体为必填项。",
  maintainDepositRequired: "保持存款为必填项。",
  maintainTurnoverRequired: "保持周转量为必填项。",
  depositOrTurnoverRequired: "存款或周转量为必填项。",
  maintainDepositOrMaintainTurnoverRequired: "保持存款或保持周转量为必填项。",
  vipListRequired: "VIP列表为必填项。",
  gameNameRequired: "游戏名称是必需的",
  claimTypeRequired: "需要索赔类型。",
  operatorIdRequired: "操作员ID为必填项。",
  maxBonusRequired: "需要最大奖金。",
  endTimeRequired: "需要结束时间。",
  mondayRequired: "需要星期一。",
  tuesdayRequired: "需要星期二。",
  wednesdayRequired: "需要星期三。",
  thursdayRequired: "需要星期四。",
  fridayRequired: "需要星期五。",
  saturdayRequired: "需要星期六。",
  sundayRequired: "需要星期天。",
  promotionTypeRequired: "促销类型为必填项。",
  claimLimitRequired: "领取限制为必填项。",
  bonusRate1Required: "奖金率1为必填项。",
  bonusRate1To2Required: "奖金率1到2为必填项。",
  bonusRate1To3Required: "奖金率1到3为必填项。",
  bonusRate1To4Required: "奖金率1到4为必填项。",
  bonusRate1To5Required: "奖金率1到5为必填项。",
  bonusRate1To6Required: "奖金率1到6为必填项。",
  bonusRate1To7Required: "奖金率1到7为必填项。",
  externalIdRequired: "外部ID为必填项。",
  opsiteRequired: "对方为必填项。",
  opsiteContentRequired: "对方内容为必填项。",
  opsiteLanguageRequired: "对方语言为必填项。",
  opsitePaymentRequired: "对方支付方式为必填项。",
  opsiteProviderRequired: "对方提供商为必填项。",
  opsiteProviderGamesRequired: "对方提供的游戏为必填项。",
  accountTypeRequired: "需要帐户类型。",
  domainNameRequired: "域名是必需的",
  settledTimeRequired: "结算时间为必填项。",
  validTurnoverRequired: "有效流水为必填项。",
  resultTimeRequired: "结果时间为必填项。",
  resultStatusRequired: "结果状态为必填项。",
  secondIdRequired: "第二ID为必填项。",
  domainListRequired: "域名列表为必填项。",
  domainTypeRequired: "域名类型是必需的",
  moduleRequired: "模块为必填项。",
  gameIdRequired: "需要游戏 ID。",
  gameDetailRequired: "游戏详情是必填项。",
  bonusRate1To8Required: "奖金率1至8是必填项。",
  bonusRate1To9Required: "奖金率1至9是必填项。",
  bonusRate1To10Required: "奖金率1至10是必填项。",
  invalidOrder: "无效的订单。",
  bannerNotExists: "横幅不存在。",
  invalidBannerType: "无效的横幅类型。",
  pageNameExists: "页面名称已存在。",
  pageNotExists: "此用户已存在。",
  tacIsValid: "OTP有效。",
  invalidTac: "无效的OTP。",
  tacExpired: "OTP已过期。",
  tacNotValidate: "OTP 尚未验证。",
  paymentModeNotExists: "支付方式不存在。",
  paymentOptionProviderNotExists: "支付选项提供商不存在。",
  ipAddressExists: "IP地址已存在。",
  ticketProcessed: "票务已处理。",
  bankAccountNotExists: "银行账户不存在。",
  bankAccountInactive: "银行账户已停用。",
  bankMemberNotExists: "银行会员不存在。",
  bankMemberInactive: "银行会员已停用。",
  affiliateExists: "会员已存在。",
  contactPhoneExists: "联系方式已存在。",
  affiliateFull: "会员已满。",
  uplineInactive: "上级已停用。",
  applicationProcessed: "申请已处理。",
  tacValidated: "条款与条件已验证。",
  applicationPending: "申请待处理。",
  favouriteGameExists: "收藏的游戏已存在。",
  invalidLimit: "无效的限制。",
  settingNotSet: "设置未配置。",
  domainNameNotExists: "域名不存在。",
  domainNameFull: "域名已满。",
  domainNameNotAvailable: "域名不可用。",
  domainNameExists: "域名已存在。",
  subAccountNotExists: "子账户不存在。",
  settingNotExists: "设置不存在。",
  invalidContactEmail: "无效的联系邮箱。",
  accountInactive: "帐户不活跃。",
  campaignNotExists: "活动不存在。",
  paymentProviderNotExists: "支付提供商不存在。",
  profileInactive: "账户已停用。",
  minWithdrawalNotMet: "未达到最低提款要求。",
  invalidBankId: "无效的银行ID。",
  bankAccountExists: "银行账户已存在。",
  bankAccountFull: "银行账户已满。",
  bankAccHolderNotSame: "银行账户持有人不一致。",
  exceedMaxWithdrawal: "超过最大提款金额。",
  exceedWithdrawalFrequency: "超过提款频率限制。",
  invalidPackage: "无效的套餐",
  promotionNotAvailable: "促销不可用。",
  ongoingPromotion: "正在进行的促销活动。",
  pendingResultInGame: "游戏结果待处理。",
  labelNameExists: "标签名称已存在。",
  labelNotExists: "标签不存在。",
  invalidFtdMin: "无效的首次存款最低金额。",
  invalidFtdMax: "无效的首次存款最高金额。",
  ftdMinGtFtdMax: "首次存款最低金额大于最高金额。",
  vipFull: "VIP名额已满。",
  invalidRewardType: "无效的奖励类型。",
  vipExists: "VIP已存在。",
  vipNotExists: "VIP不存在。",
  onlyOneMaxWithdrawSetting: "只能设置一个最大提款限制。",
  onlyOneWithholdSetting: "只能设置一个扣款限制。",
  campaignExists: "活动已存在。",
  vipProviderNotExists: "VIP提供商不存在。",
  turnoverTierExists: "营业额等级已存在。",
  turnoverTierFull: "营业额等级超过最大等级。",
  turnoverTierNotExists: "投注层级不存在。",
  invalidSettingValue: "无效的设置值。",
  turnoverTierNotSet: "投注层级未设置。",
  rebateProcessed: "返利已处理。",
  invalidActionType: "无效的操作类型。",
  invalidRescueCycle: "无效的援助周期。",
  invalidPayoutMethod: "无效的付款方式。",
  invalidTargetGroup: "无效的目标群体。",
  rescueExists: "援助已存在。",
  rescueNotExists: "援助不存在。",
  walletExists: "钱包已存在。",
  accountExists: "账户已存在。",
  activeFromGtActiveTo: "开始时间大于结束时间。",
  accountNotExists: "运营商ID不存在。",
  invalidDeposit: "无效的存款。",
  invalidTurnover: "无效的投注量。",
  providerCodeNotExists: "提供商代码不存在。",
  gameNameExists: "游戏名称已存在。",
  gameNameNotExists: "游戏名称不存在。",
  invalidAccountType: "无效的帐户类型。",
  invalidLoginIdFormat: "无效的登录ID格式。",
  invalidReferralCode: "无效的推荐码。",
  firstDepositNotMet: "未达到首次存款要求。",
  newbieNotMet: "新手要求未满足。",
  claimPromoOnlyOnce: "每个促销只能领取一次。",
  promotionRequirementNotMet: "未满足促销要求。",
  withdrawalAmountLteWithholdAmount: "提现金额小于或等于扣留金额。",
  subAccountInactive: "子账户不活跃。",
  gameNotSupported: "游戏不支持。",
  startTimeGteEndTime: "开始时间大于或等于结束时间。",
  invalidPromotionType: "无效的促销类型。",
  invalidClaimType: "无效的领取类型。",
  claimLimitExceeded10: "领取次数超过10次。",
  verificationFailed: "验证失败。",
  claimLimitReached: "已达到领取限制。",
  invalidPromotion: "无效的促销。",
  socialPlatformExists: "社交平台已存在。",
  duplicateReview: "重复评论。",
  invalidSurveyId: "无效的调查ID。",
  accountNotBlock: "账户未被封锁。",
  walletNotExists: "钱包不存在。",
  socialPlatformNotExists: "社交平台不存在。",
  socialPlatformInactive: "社交平台不活跃。",
  accountSocialExists: "社交账户已存在。",
  invalidStatus: "无效的状态",
  samePassword: "新密码不能与旧密码相同。",
  invalidPassword: "密码错误",
  secondaryAccountExists: "次级账户已存在。",
  invalidSecurityCode: "无效的安全码。",
  accountSocialNotExists: "账户社交信息不存在。",
  providerInactive: "提供商不活跃。",
  gameIdExists: "游戏ID已存在。",
  gameIdNotExists: "游戏ID不存在。",
  parentProviderInactive: "父级提供商不活跃。",
  betLimitNotExists: "投注限额不存在。",
  min3Characters: "最少3个字符。",
  invalidBankAccType: "无效的银行账户类型。",
  senderBankNotExists: "发送银行不存在。",
  recipientBankNotExists: "接收银行不存在。",
  affiliateNotExists: "附属账户不存在。",
  redepositedTicket: "已重新存入的票。",
  invalidDepositType: "无效的存款类型。",
  affiliateInactive: "附属账户不活跃。",
  bonusUnavailable: "奖金不可用。",
  pendingDeposit: "待处理存款。",
  noOngoingPromotion: "没有进行中的促销。",
  iframeNotExists: "IFrame不存在。",
  gameMaintenance: "游戏维护中。",
  labelInactive: "标签不活跃。",
  invalidDomainType: "无效的域名类型。",
  invalidModule: "无效的模块。",
  labelFull: "标签已满。",
  questionExists: "问题已存在。",
  questionFull: "问题已满。",
  questionNotExists: "问题不存在。",
  reviewNotExists: "评论不存在。",
  invalidDomainGroup: "无效的域名组。",
  invalidDateRange: "无效的日期范围。",
  ipAddressNotExists: "IP地址不存在。",
  marqueeNotExists: "滚动字幕不存在。",
  invalidAmount: "无效金额。",
  insufficientBalance: "余额不足。",
  minLimitLtParent: "最小限额小于父级。",
  maxLimitGtParent: "最大限额大于父级。",
  startDateGtEndDate: "开始日期大于结束日期。",
  currencyNotExists: "货币不存在。",
  currencyExists: "货币已存在。",
  noAccumulateWin: "没有累积赢得。",
  invalidSession: "无效的会话。",
  sessionExpired: "会话已过期。",
  promotionExists: "促销已存在。",
  invalidCriteria: "无效的标准。",
  promotionNotExists: "促销不存在。",
  ticketNotExists: "票据不存在。",
  duplicateDebitRecord: "重复的借记记录。",
  duplicateCreditRecord: "重复的贷记记录。",
  debitRecordNotExists: "借记记录不存在。",
  minDepositNotMet: "未达到最低存款要求。",
  duplicateBet: "重复的投注。",
  invalidProviderCode: "无效的提供商代码。",
  resultExists: "结果已存在。",
  unableSPProcess: "系统无法处理您的请求。",
  authRequired: "需要验证码。",
  domainExists: "域名已存在。",
  multiSelectOption: "请选择{fname}",
  invalidDomainFormat: "域名格式无效",
  noHttpHttps: "'https://' 或 'http://' 不允许。",
  noReservedSubdomain: "保留的子域名不允许使用，用于应用下载链接。",
  operatorInactive: "操作员不活跃。",
  invalidAccountIdFormat: "账户ID格式无效",
  contentIdRequired: "菜单ID是必需的",
  themeCodeRequired: "主题代码是必需的",
  themeNameRequired: "主题名称是必需的",
  themeColorRequired: "主题颜色是必需的",
  languageRequired: "语言是必需的",
  positionRequired: "位置是必需的",
  themeContentIdRequired: "主题内容ID是必需的",
  emailRequired: "电子邮件是必需的",
  themeProviderTypeRequired: "主题提供商类型是必需的",
  phoneRequired: "电话是必需的",
  targetTypeRequired: "目标类型是必需的",
  packageTypeRequired: "套餐类型是必需的",
  renewTermRequired: "续约条款是必需的",
  packagePriceRequired: "套餐价格是必需的",
  packageStatusRequired: "套餐状态是必需的",
  sortKeyRequired: "排序键是必需的",
  invalidDomainStatus: "无效的域名状态",
  invalidCurrency: "无效的货币",
  invalidThemeCode: "无效的主题代码",
  invalidLanguage: "无效的语言",
  invalidPosition: "无效的位置",
  invalidThemeContent: "无效的主题内容",
  allParamsSameAsCurrent: "没有任何更改",
  invalidThemeColor: "无效的主题颜色",
  invalidCartStatus: "无效的购物车状态",
  invalidThemeProviderType: "无效的主题提供商类型",
  themeProviderTypeCannotBeUse: "主题提供商类型无法使用",
  invalidUserStatus: "无效的用户状态",
  packageCannotBeRemove: "套餐无法删除",
  userStatusIsAlrdSuspend: "用户已被暂停",
  userStatusIsAlrdBlocked: "用户已被封锁",
  userStatusIsAlrdActive: "用户已激活",
  invalidSortType: "无效的排序类型",
  startDateBiggerThanEndDate: "开始日期大于结束日期",
  positionCannotBeUse: "位置无法使用",
  funcAddContentFailed: "添加内容失败",
  funcDeleteContentFailed: "删除内容失败",
  funcUpdateContentFailed: "更新内容失败",
  funcAddThemeFailed: "添加主题失败",
  funcDeleteThemeFailed: "删除主题失败",
  funcUpdateThemeFailed: "更新主题失败",
  funcAddThemeColorFailed: "添加主题颜色失败",
  funcDeleteThemeColorFailed: "删除主题颜色失败",
  funcUpdateThemeColorFailed: "更新主题颜色失败",
  funcAddLanguageFailed: "添加语言失败",
  funcDeleteLanguageFailed: "删除语言失败",
  funcUpdateLanguageFailed: "更新语言失败",
  funcAddThemeContentFailed: "添加主题内容失败",
  funcDeleteThemeContentFailed: "删除主题内容失败",
  funcUpdateThemeContentFailed: "更新主题内容失败",
  funcAddContentPositionFailed: "添加内容位置失败",
  funcUpdateContentPositionFailed: "更新内容位置失败",
  funcDeleteContentPositionFailed: "删除内容位置失败",
  funcAddThemeProviderTypeFailed: "添加主题提供商类型失败",
  funcUpdateThemeProviderTypeFailed: "更新主题提供商类型失败",
  funcDeleteThemeProviderTypeFailed: "删除主题提供商类型失败",
  funcAddPackageFailed: "添加套餐失败",
  funcUpdatePackageFailed: "更新套餐失败",
  funcDeletePackageFailed: "删除套餐失败",
  nicknameRequired: "昵称是必需的",
  accountStatusRequired: "账户状态是必需的",
  contentIdMaxLength50: "菜单ID的最大长度为50",
  positionMaxLength10: "位置的最大长度为10",
  contentDescMaxLength200: "内容描述的最大长度为200",
  domainStatusRequired: "域名状态是必需的",
  funcAddDomainFailed: "添加域名失败",
  funcUpdateDomainFailed: "更新域名失败",
  uploadFailed: "上传失败！",
  sortKeyMaxLength50: "排序键的最大长度为50",
  invalidSortTypeFormat: "无效的排序类型格式",
  invalidPackageId: "无效的套餐ID",
  invalidAccountStatusFormat: "无效的账户状态格式",
  invalidSiteStatusFormat: "无效的站点状态格式",
  invalidPackageStatus: "无效的套餐状态",
  invalidEmailFormat: "无效的电子邮件格式",
  invalidPhoneFormat: "无效的电话号码格式",
  languageLengthNotInRange: "语言长度不在范围内 (2-5)",
  languageDescriptionMaxLength50: "语言描述的最大长度为50",
  remarkMaxLength500: "备注的最大长度为500",
  themeProviderTypeMaxLength50: "主题提供商类型的最大长度为50",
  themeNameMaxLength50: "主题名称的最大长度为50",
  themeColorMaxLength20: "主题颜色的最大长度为20",
  noSpace: "不得含有空格",
  packageDescEnRequired: "英文名称是必需的",
  packageDescEnMaxLength20: "英文名称的最大长度为20",
  allParamsIsNull: "所有参数为空",
  contentCannotBeRemove: "内容无法删除",
  contentDetailsRequired: "内容详情是必需的",
  domainCannotBeUse: "域名无法使用",
  domainGroupMaxLength20: "域名组最大长度为20",
  domainGroupRequired: "域名组是必需的",
  domainNameCannotUpdate: "域名无法更新",
  domainNameMaxLength400: "域名最大长度为400",
  domainsRequired: "域名是必需的",
  domainStatusMaxLength20: "域名状态最大长度为20",
  domainTypeMaxLength10: "域名类型最大长度为10",
  funcAddThemeContentGroupFailed: "添加主题内容组失败",
  funcDeleteThemeContentGroupFailed: "删除主题内容组失败",
  funcOpsiteUpdateFailed: "Opsite更新失败",
  funcResetAccountPasswordFailed: "重置账户密码失败",
  funcSiteLanguageUpsertFailed: "站点语言更新失败",
  funcSiteThemeContentUpsertFailed: "站点主题内容更新失败",
  funcSiteThemeUpsertFailed: "站点主题更新失败",
  funcSiteUpdateFailed: "站点更新失败",
  funcUpdateAccountFailed: "更新账户失败",
  funcUpdateAccountStatusActiveFailed: "激活账户状态失败",
  funcUpdateAccountStatusCompanyBlockFailed: "更新账户状态为公司封锁失败",
  funcUpdateAccountStatusSuspendFailed: "更新账户状态为暂停失败",
  funcUpdateThemeContentGroupFailed: "更新主题内容组失败",
  invalidBoDomain: "无效的BO域名",
  invalidOperatorIdFormat: "无效的操作员ID格式",
  invalidOpsite: "无效的Opsite",
  invalidOpsiteOperator: "无效的Opsite操作员",
  invalidOpsiteVersion: "无效的Opsite版本",
  invalidParentContentInGroup: "组中的上级内容无效",
  invalidSite: "无效的站点",
  invalidSiteStatus: "无效的站点状态",
  invalidThemeContentGroup: "无效的主题内容组",
  languageCannotBeUse: "语言无法使用",
  languagesRequired: "语言是必需的",
  logo1Required: "Logo 是必需的",
  notSupportMultiDefault: "不支持多默认值",
  operatorIdMaxLength50: "操作员ID最大长度为50",
  opsiteNotMatch: "Opsite不匹配",
  packageTypeMaxLength15: "套餐类型最大长度为15",
  parentContentIdCannotSameWithContentId: "上级内容ID不能与内容ID相同",
  phoneNumberRequired: "电话号码是必需的",
  siteIdRequired: "站点ID是必需的",
  siteNameMaxLength50: "站点名称最大长度为50",
  siteNameRequired: "站点名称是必需的",
  technicalError: "技术错误",
  themeCannotBeRemove: "主题无法删除",
  themeCodeCannotBeUse: "主题代码无法使用",
  themeCodeMaxLength20: "主题代码最大长度为20",
  themeColorCannotBeRemove: "主题颜色无法删除",
  themeColorCannotBeUse: "主题颜色无法使用",
  themeContentCannotBeUse: "主题内容无法使用",
  themeContentGroupCannotBeUse: "主题内容组无法使用",
  themeContentGroupDescriptionMaxLength50: "主题内容组描述最大长度为50",
  themeContentGroupMaxLength20: "主题内容组最大长度为20",
  themeContentGroupRequired: "主题内容组是必需的",
  themeNameCannotBeUse: "主题名称无法使用",
  userHaventVerifyThisBefore: "用户之前没有验证此内容",
  isDefaultTrueRequired: "语言必须有1个默认值",
  accountIdMaxLength50: "用户 ID 的最大长度为 50",
  headBodyScriptEitherOne: "请输入头部脚本或主体脚本",
  alphaOrNum: "只能包含字母或数字",
  phoneValid: "请输入有效的电话号码",
  permittedAmountRequired: "需要许可金额",
  ignoreRiskRequired: "需要忽略风险",
  paymentDescRequired: "需要支付描述",
  gameTypeRequired: "需要游戏类型",
  statusRequired: "需要状态",
  payoutIdRequired: "需要支付 ID",
  commNotExists: "委托不存在",
  parentCommNotExists: "上级佣金不存在",
  carryOverNotExists: "结转不存在",
  hotGameExists: "热门游戏已存在",
  commSportsExceededParent: "体育佣金超出上级",
  commSlotsExceededParent: "老虎机佣金超出上级",
  commLivecasinoExceededParent: "真人娱乐佣金超出上级",
  commCockfightExceededParent: "斗鸡佣金超出上级",
  commOthersExceededParent: "其他佣金超出上级",
  hotGameNotExists: "热门游戏不存在",
  noSecurityDeposit: "没有保证金",
  exchangeRateNotExists: "保证金不足",
  insufficientSecurityDeposit: "保证金不足",
  duplicateDomain: "重复的域名",
  contactEmailNotExists: "联系邮箱不存在",
  featuredGameNotExists: "推荐游戏不存在",
  newGameNotExists: "新游戏不存在",
  popularGameNotExists: "热门游戏不存在",
  featuredGameExists: "推荐游戏已存在",
  newGameExists: "新游戏已存在",
  popularGameExists: "热门游戏已存在",
  rebateNotExists: "回扣不存在",
  riskyMember: "风险会员",
  ipRestricted: "IP被限制",
  notSupportedBank: "不支持目标银行ID。",
  requestTooFrequent: "请求过于频繁",
  paymentOptionNotExists: "支付选项不存在。",
  earningIdRequired: "需要收益 ID。",
  ptOnRequired: "需要 PT 开启。",
  ptRequired: "需要 PT。",
  userIdRequired: "需要用户 ID。",
  businessIdRequired: "需要商户 ID。",
  subAccountIdRequired: "需要子账户 ID。",
  sourceAccountIdRequired: "需要来源账户 ID。",
  targetAccountIdRequired: "需要目标账户 ID。",
  ticketTaken: "票已被领取。",
  ticketNotTaken: "票未被领取。",
  invalidPt: "无效的 PT。",
  topupIdRequired: "需要充值 ID。",
  promotionMemberLogNotExists: "促销会员日志不存在。",
  paymentOptionInactive: "支付选项未启用",
  invalidCartStatusFormat: "无效的购物车状态格式",
  requestIncompleted: '请求未完成',
  unknownError: '发生未知错误',
  cartIdRequired: "购物车ID是必需项",
  stepNameRequired: "步骤名称是必需项",
  invalidCart: "购物车无效",
  invalidStepName: "步骤名称无效",
  cartHaventSetupComplete: "购物车尚未完成设置",
  funcCartCreateFailed: "创建购物车失败",
  funcCartUpdateFailed: "购物车更新失败",
  funcSiteCreateFailed: "创建网站失败",
  funcCartPurchasedUpdateFailed: "更新购物车购买信息失败",
  invalidPasswordFormat: "无效的密码格式",
  currencyCodeRequired: "货币是必需项",
  funcCartLanguageUpsertFailed: "购物车语言更新失败",
  invalidUserIdFormat: "无效的用户ID格式",
  operatorPasswordRequired: "操作员密码是必需项",
  funcCartOperatorInfoUpsertFailed: "购物车操作员信息更新失败",
  invalidOperatorPasswordFormat: "无效的运营商密码格式",
  operatorIdCannotBeUse: "运营商ID无法使用",
  siteNameLengthNotInRange: "站点名称长度不在范围内",
  userIdCannotBeUse: "用户ID无法使用",
  siteIdAlrdExist: "站点ID已存在",
  operatorIdAlrdExist: "运营商ID已存在",
  externalIdAlrdExist: "外部ID已存在",
  opsiteContentAlrdExist: "站点内容主题内容已存在",
  opsiteLanguageAlrdExist: "站点内容语言已存在",
  boAccountAlrdExist: "后台账户已存在",
  boAccountProfileAlrdExist: "后台账户已存在",
  boAccountLoginAlrdExist: "后台账户登录中",
  funcCartThemeCodeUpsertFailed: "购物车主题代码更新插入失败",
  funcCartThemeColorUpsertFailed: "购物车颜色更新插入失败",
  funcOpsiteCreateFailed: "创建站点内容失败",
  alphabetValid: "必须至少有一个大写字母和一个小写字母",
  numberValid: "必须至少有一个数字",
  symbolValid: "必须至少有一个符号",
  credentialNotSet: "凭证未设置",
  validBankAccFormat: "银行账户号码格式无效",
  moreThan: "{fname} 必须小于或等于 {fname2}",
  lessThan: "{fname} 必须大于或等于 {fname2}。",
  bankAccountNotAvailable: "银行账户不可用。",
  insufficientCredit: "信用不足",
  enableRequired: "必须启用。",
  funcAddGameFailed: "添加游戏失败。",
  funcAddGameRewardByBatchFailed: "批量添加游戏奖励失败。",
  funcAddGameRewardFailed: "添加游戏奖励失败。",
  funcAddGameTemplateFailed: "添加游戏模板失败。",
  funcAddLayoutTemplateFailed: "添加布局模板失败。",
  funcAddOperatorGameFailed: "添加运营商游戏失败。",
  funcAddOperatorMemberWalletFailed: "添加运营商会员钱包失败。",
  funcDeleteGameFailed: "删除游戏失败。",
  funcDeleteGameRewardFailed: "删除游戏奖励失败。",
  funcDeleteGameTemplateFailed: "删除游戏模板失败。",
  funcDeleteLayoutTemplateFailed: "删除布局模板失败。",
  funcDeleteOperatorGameFailed: "删除运营商游戏失败。",
  funcUpdateGameFailed: "更新游戏失败。",
  funcUpdateGameRewardFailed: "更新游戏奖励失败。",
  funcUpdateGameTemplateFailed: "更新游戏模板失败。",
  funcUpdateLayoutTemplateFailed: "更新布局模板失败。",
  funcUpdateOperatorGameFailed: "更新运营商游戏失败。",
  gameCannotBeRemove: "无法删除游戏。",
  gameNameCannotBeUse: "游戏名称不可用。",
  gameNameMaxLength150: "游戏名称最长150个字符。",
  gameRewardCannotBeUse: "游戏奖励不可用。",
  gameRewardLimitExceeded: "超过游戏奖励限制。",
  gameTemplateExist: "游戏模板已存在。",
  gameTypeMaxLength20: "游戏类型最长20个字符。",
  invalidGame: "无效的游戏。",
  invalidGameReward: "无效的游戏奖励。",
  invalidGameTemplate: "无效的游戏模板。",
  invalidMemberWallet: "无效的会员钱包。",
  invalidOperatorGame: "无效的运营商游戏。",
  invalidRewardProbability: "无效的奖励概率。",
  invalidTemplate: "无效的模板。",
  maxGameRewardRequired: "必须指定最大游戏奖励。",
  maxMiniGameRewardRequired: "必须指定最大小游戏奖励。",
  memberWalletAlrdExist: "会员钱包已存在。",
  operatorGameCannotBeUse: "运营商游戏不可用。",
  operatorGameIdRequired: "必须指定运营商游戏ID。",
  rewardCodeMaxLength20: "奖励代码最长20个字符。",
  rewardCodeRequired: "必须指定奖励代码。",
  rewardCurrencyMaxLength5: "奖励货币代码最长5个字符。",
  rewardCurrencyRequired: "必须指定奖励货币。",
  rewardDescriptionMaxLength100: "奖励描述最长100个字符。",
  rewardNameMaxLength50: "奖励名称最长50个字符。",
  rewardProbabilityRequired: "必须指定奖励概率。",
  rewardRequired: "必须指定奖励。",
  selectedTemplateMaxLength30: "所选模板最长30个字符。",
  selectedTemplateRequired: "必须选择模板。",
  success: "成功。",
  templateCannotBeRemove: "无法删除模板。",
  templateCodeCannotBeUse: "模板代码不可用。",
  templateCodeMaxLength30: "模板代码最长30个字符。",
  templateCodeRequired: "必须指定模板代码。",
  templateNameMaxLength50: "模板名称最长50个字符。",
  tokenRequestRequired: "必须指定令牌请求。",
  tokenRequired: "必须指定令牌。",
  mustMoreThan: "{fname} 必须大于 {fvalue}。",
  mustMoreThanOrEqual: "{fname} 必须大于或等于 {fvalue}。",
  tokenInvalid: "令牌输入在 {key} 无效",
  cashInvalid: "现金输入在 {key} 无效",
  atLeastOneRequired: "至少需要一个",
  cash1To7Required: "需要填写现金 1 到 7",
  cash1To6Required: "需要填写现金 1 到 6",
  cash1To5Required: "需要填写现金 1 到 5",
  cash1To4Required: "需要填写现金 1 到 4",
  cash1To3Required: "需要填写现金 1 到 3",
  cash1To2Required: "需要填写现金 1 到 2",
  cash1Required: "需要填写现金 1",
  token1To7Required: "需要填写代币 1 到 7",
  token1To6Required: "需要填写代币 1 到 6",
  token1To5Required: "需要填写代币 1 到 5",
  token1To4Required: "需要填写代币 1 到 4",
  token1To3Required: "需要填写代币 1 到 3",
  token1To2Required: "需要填写代币 1 到 2",
  token1Required: "需要填写代币 1",
  cycleRequired: "需要填写周期",
  targetAmountRequired: "需要填写目标金额",
  gamifyIdRequired: "需要填写奖励ID",
  gamifyMemberProcessed: "奖励会员已处理",
  gamifyNotExists: "奖励不存在",
  gamifyInactive: "奖励未启用",
  invalidCycle: "周期无效",
  memberIdMaxLength50: "会员ID不能超过50个字符",
  funcAddGameWalletFreeCreditFailed: "添加免费游戏钱包余额失败",
  funcUpdateOperatorMemberWalletBalanceFailed: "更新运营商会员钱包余额失败",
  funcUpdateOperatorMemberWalletBalanceByFrozenFailed: "通过冻结金额更新运营商会员钱包余额失败",
  mustHaveBothAlphaNumOnly: "只能使用字母和数字，且至少各包含一个。",
  setupGameRewardBeforeEnable: "请先设置游戏奖励后再启用。",
  rewardProbabilityMustNotAllZero: "奖励概率不能全部为零。",
  totalRewardProbabilityCannotOver100: "奖励总概率不能超过100。",
  credential1To2Required: "第1至第2项凭证为必填项。",
  credential1To4Required: "第1至第4项凭证为必填项。",
  newRemarkRequired: "备注为必填项。",
  notSupportedWithdrawalPG: "不支持提现的支付网关。",
  prizeInvalid: "奖品输入在 {key} 无效",
  exceedMaxCampaignCount: "已超出排行榜活动的最大数量。",
  leaderboardCampaignEnded: "排行榜活动已结束。",
  leaderboardCampaignStarted: "排行榜活动已开始",
  leaderboardCampaignSettled: "排行榜活动已结算",
  pleaseSelectUpToNoPhone: "请选择最多 {fname} 个电话号码。",
  phoneNotAvailable: "电话不可用。",
  batchExpired: "批次已过期。",
  remarkNotSame: "备注不一致",
  partnerIdRequired: "需要合作伙伴ID",
  partnerNotExists: "合作伙伴不存在",
  urgencyRequired: "需要紧急程度",
  groupSizeRequired: "需要分组大小",
  inactiveDaysRequired: "需要填写不活跃天数",
  idRequired: "需要ID",
  expiryRequired: "需要到期日期",
  batchIdRequired: "需要批次ID",
  requestDateRequired: "需要请求日期",
  requestByRequired: "需要请求人",
  cpiIdRequired: "需要CPI ID",
  assigneeRequired: "需要负责人",
  phoneNotAvailable: "电话不可用",
  liveChatNotExists: "在线客服不存在",
  resultNotExists: "结果不存在",
  lastLaunchFundTransfer: "上次启动资金转账",
  alreadyRegistered: "已注册",
  invalidId: "无效的ID",
  batchExpired: "批次已过期",
  teleCalling: "电话呼叫",
  invalidUrgency: "无效的紧急程度",
  appTypeRequired: "需要应用类型",
  invalidAppType: "无效的应用类型",
  appLinkRequired: "需要应用链接",
  invalidDomain: "无效的域名",
  existEndDateGtEndDate: "现有结束日期晚于新结束日期",
  newRemark2Required: "需要新的备注2",
  remark2NotSame: "备注2不一致",
  remark2Required: "需要备注2",
  nameRequired: "需要名称",
  aiAssistantNotExists: "AI助手不存在",
  aiAssistantInactive: "AI助手未启用",
  phoneStartWithVND: "电话号码必须以 84 开头",
  otherActiveLiveChat: "有其他正在进行的LiveChat",
  whiteLabelRequired: "需要 White Label",
  invalidWhiteLabel: "无效的 White Label",
  invalidWhiteLabel: "无效的 White Label",
  baseRateDepositRequired: "需要基础存款利率",
  revisionRequired: "需要修订",
  typeDescRequired: "需要类型描述",
  riskWeightRequired: "需要风险权重",
  linkageTypeRequired: "需要关联类型",
  valueRequired: "需要数值",
  baseRateWithdrawalRequired: "需要基础提款利率",
  sourceIdRequired: "需要来源 ID",
  targetIdRequired: "需要目标 ID",
  linkageTypeNotExists: "关联类型不存在",
  phoneStartWithMYR: "电话号码必须以 60 开头",
  minWithdrawalAmount100: "最低提现金额为 100",
  invalidReward: "无效奖励",
  noRow: "没有数据",
  credentialRequired: "需要凭证",
  settlementIdRequired: "需要结算ID",
  settlementDateRequired: "需要结算日期",
  newCryptoAddressRequired: "需要新的加密地址",
  cryptoAddressRequired: "需要加密地址",
  settlementTypeRequired: "需要结算类型",
  chatProviderRequired: "需要聊天提供商",
  countRequired: "需要数量",
  voucherCodeRequired: "需要凭证代码",
  eventTypeRequired: "需要事件类型",
  viewTypeRequired: "需要视图类型",
  actionTypeRequired: "需要操作类型",
  thresholdRequired: "需要阈值",
  missionIdRequired: "需要任务ID",
  ruleIdRequired: "需要规则ID",
  aggregatorRequired: "需要聚合器",
  rebateIdRequired: "需要返利ID",
  liveChatExists: "该在线聊天已存在",
  triggerNotExists: "触发器不存在",
  missionRuleNotExists: "任务规则不存在",
  invalidVoucherCode: "无效的凭证代码",
  invalidRebateType: "无效的返利类型",
  invalidSettlementType: "无效的结算类型",
  missionNotExists: "任务不存在",
  settlementTypeNotExists: "结算类型不存在",
  parentTriggerInactive: "父触发器未激活",
  parentMissionInactive: "父任务未激活",
  missionRuleNotSet: "任务规则未设置",
  invalidCreditType: "无效的信用类型",
  cryptoDisabled: "加密已禁用",
  depositExists: "存款已存在",
  parentSettlementTypeNotExists: "父结算类型不存在",
  accessControlNotExists: "访问控制不存在",
  cryptoAccountFull: "加密账户已满",
  cryptoAccountExists: "加密账户已存在",
  cryptoAccountNotExists: "加密账户不存在",
  settlementNotAvailable: "结算不可用",
  settlementProcessed: "结算已处理",
  cryptoAccountInactive: "加密账户未激活",
  leadIdRequired: "需要线索ID",
  failedToCreateFreeRound: "创建免费回合失败。",
  failedToGetFreeRound: "获取免费回合失败。",
  failedToGetFreeRoundGameList: "获取免费回合游戏列表失败。",
  tierFull: "等级已满",
  tierNotExists: "等级不存在",
  ticketTypeRequired: "票券类型为必填项",
  invalidTicketType: "票券类型无效",
  positionRequired: "位置为必填项",
  invalidPosition: "位置无效",
  invalidBonusRate: "奖金比例无效",
  minRequired: "最小值为必填项",
  maxRequired: "最大值为必填项",
  minGtMax: "最小值大于最大值。",
  sessionExists: "场次已存在",
  sessionOverlaps: "场次重叠",
  sessionIdRequired: "场次 ID 为必填项",
  sessionNotExists: "场次不存在",
  nameExists: "名称已存在",
  sessionElapsed: "场次已结束",
  validUrl: "请输入有效的 URL",
  minBalanceNotMet: "未达到最低余额",
  validSlugFormat: "网址别名格式无效",

  failedToCancelFreeRound: "取消免费回合失败。",
  failedToGetFreeRoundLineBet: "获取免费回合线路投注失败。",
};